/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC} from 'react'
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'
import {PrivateRoutes} from './PrivateRoutes'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {Logout, AuthPage, useAuth} from '../modules/auth'
import {App} from '../App'
import {LandingPage} from '../modules/landing/landing'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
  const {currentUser} = useAuth()
  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          {currentUser ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              {currentUser?.roles[0]  === 'Client admin' && <Route index element={<Navigate to='/landing' />} />}
              {currentUser?.roles[0]  === 'Super admin' && <Route index element={<Navigate to='/backoffice/dashboard' />} />}
            </>
          ) : (
            <>
              <Route path='landing/*' element={<LandingPage />} />
              {/* <Route path='customer/post-job' element={<PostJob />} /> */}
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='services' element={<LandingPage />} />
              <Route path='/become-a-handyman' element={<LandingPage />} />
              <Route path='/faq' element={<LandingPage />} />
              <Route path='/privacy-policy' element={<LandingPage />} />
              <Route path='/terms-and-conditions' element={<LandingPage />} />
              <Route path='/About-us' element={<LandingPage />} />
              <Route path='/Contact-us' element={<LandingPage />} />
              <Route path='*' element={<Navigate to='/landing' />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export {AppRoutes}
